module.exports = __webpack_public_path__ + "img/vignettes-asso_0010_sport-dans-la-ville.4b5b4b4d.jpg";